import translations from './barium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/barium'

export const barium: Metal = {
  id: 23,
  slug: 'barium',
  name: t.name,
  symbol: 'Ba',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Mangampet, barium mine (India)',
      region: 'Mangampet',
      coordinates: [79.28, 14.05],
    },
    {
      name: 'Elko, barium mine (United States)',
      region: 'Elko',
      coordinates: [-115.76, 40.83],
    },
    {
      name: 'Battle Mountain, barium mine (United States)',
      region: 'Battle Mountain',
      coordinates: [-116.93, 40.64],
    },
    {
      name: 'Majiang, barium mine (China)',
      region: 'Majiang',
      coordinates: [107.6, 26.49],
    },
    {
      name: 'Lipu, barium mine (China)',
      region: 'Lipu',
      coordinates: [110.39, 24.49],
    },
  ],
  // Barite mine production, not barium metal — see the `**` footnote.
  countries: [
    { name: 'India', percent: 24 },
    { name: 'China', percent: 19.4 },
    { name: 'Morocco', percent: 9.2 },
    { name: 'Kazakhstan', percent: 6 },
    { name: 'Mexico', percent: 3 },
  ],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: null, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
